<template>
  <div class="pnf">
    <h2>404 Error</h2>
    <h1>Sorry, we can’t seem to find what you’re looking for.</h1>
    <p><span>You've landed on a URL that doesn't seem to exist on totalflow.</span></p>
    Here's some options:
    <ul> 
      <li>If you think this is an error on our part, please let us know.</li>
      <li>You could try to search in the address bar to find what you’re looking for</li>
      <li>Just click back to return to your previous page </li>
    </ul>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.pnf {
  padding: 80px 0 0 30px;
  text-align: left;
  font-family: monaco, monospace;
}
h1 {
  font-size: 30px
}
h2 {
  font-size: 20px;
}
p {
  margin: 0;
  span {
    background: #fd0;
  }
}
</style>